export default __webpack_public_path__ + "static/media/hellonearth.44d091f9.png";